import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcoSound = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.375 14.781V28.22M13.438 10.302v22.396M21.5 5.823v31.354M29.563 10.302v22.396M37.625 14.781V28.22"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoSound;
